import IconCorrect from '@icon/variable/correct.svg'
import { cn } from '@utils'

export function Group({
  title,
  titleBgColor,
  items,
  className,
}: {
  title: string
  titleBgColor?: string
  titleBold?: boolean
  items: React.ReactNode[]
  className?: string
}) {
  return (
    <div className={cn('flex bg-white', className)}>
      <div
        className='lg:w-17 shrink-0 text-white flex-col items-center justify-center lg:text-4xl px-7.5 hidden md:flex'
        style={{
          writingMode: 'sideways-lr',
          backgroundColor: titleBgColor,
        }}
      >
        {title}
      </div>
      <div
        className='flex-1 grid'
        style={{
          gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))`,
        }}
      >
        {items.map((item) => item)}
      </div>
    </div>
  )
}

export function GroupItem({
  items,
  className,
}: {
  items: React.ReactNode[]
  className?: string
}) {
  return (
    <div
      className={cn('grid grid-rows-subgrid', className)}
      style={{
        gridRow: `span ${items.length} / span ${items.length}`,
      }}
    >
      {items.map((item) => item)}
    </div>
  )
}

export type CellData =
  | {
      type: 'text' | 'support' | 'not-support' | 'support-text'
      content: string
    }
  | {
      type: 'head'
      content: {
        name: string
        brief: string
        price: string
        bold: boolean
        color: string
      }
    }

export function GroupCell({
  data,
  className = '',
}: {
  data: CellData
  className?: string
}) {
  const content = (function () {
    switch (data.type) {
      case 'text':
        return (
          <span className='text-xs md:text-sm lg:text-base text-center break-all'>
            {data.content}
          </span>
        )
      case 'support':
        return <IconCorrect className='w-4.5 h-4 lg:w-6 lg:h-4.5 fill-[#0E6CC1]' />
      case 'not-support':
        return <span className='text-5xl font-light text-[#BBBBBB]'>-</span>
      case 'support-text':
        return (
          <span className='text-center text-[#0E6CC1]'>
            <IconCorrect className='w-4.5 h-4 lg:w-6 lg:h-4.5 fill-[#0E6CC1]' />
            <div className='mt-1 font-medium break-all text-sm lg:text-base'>
              {data.content}
            </div>
          </span>
        )
      case 'head':
        return (
          <div
            className={cn(
              'text-center w-full h-full flex flex-col gap-y-1 py-4',
              data.content.price ? 'justify-between' : 'justify-center'
            )}
          >
            <div
              className={cn(
                'text-sm lg:text-4xl text-[#0060B8]',
                data.content.bold ? 'font-bold' : 'font-medium'
              )}
            >
              {data.content.name}
            </div>
            {data.content.brief && (
              <p className='text-xs md:text-sm lg:text-base font-medium'>
                {data.content.brief}
              </p>
            )}
            {/* {data.content.price && (
              <div
                className='py-2 lg:py-4 rounded-4xl flex flex-col lg:flex-row items-center justify-center text-white gap-x-1'
                style={{ backgroundColor: data.content.color }}
              >
                <span className='lg:text-4xl font-bold'>
                  ${data.content.price}
                </span>
                <span className='text-xs md:text-sm lg:text-xl'>incl. GST</span>
              </div>
            )} */}
          </div>
        )
    }
  })()
  return (
    <div
      className={cn(
        'flex items-center justify-center min-h-16.5 px-0.5 py-1 lg:px-4',
        className
      )}
    >
      {content}
    </div>
  )
}
